import Icon from "components/Common/Icon";
import { getWowStatic } from "hooks/wow/getStaticData";
import { formatEnchantName, getEnchantImgSrc, getEnchantQualityIconSrc } from "lib/enchant-display";
import EnchantTooltip from "../Tooltips/EnchantTooltip";
import React from "react";
import WowTooltip from "../Tooltips/WowTooltip";
import CraftedIcons from "./CraftedIcons";
import GemIcons from "./GemIcons";

const ArmorItemCombo = ({ data, encounterType }) => {
  let firstItemId, secondItemId, firstItemEnchant, secondItemEnchant, popularity, count;

  firstItemId = data?.first_item_id;
  secondItemId = data?.second_item_id;
  firstItemEnchant = data?.first_item_enchant_name;
  secondItemEnchant = data?.second_item_enchant_name;
  popularity = data?.popularity;
  count = data?.count;

  const firstItemBonusIds = data?.first_item_bonus_ids;
  const secondItemBonusIds = data?.second_item_bonus_ids;
  const firstItemCraftingQuality = data?.first_item_crafted_quality;
  const secondItemCraftingQuality = data?.second_item_crafted_quality;
  const firstItemEnchantId = data?.first_item_enchant;
  const secondItemEnchantId = data?.second_item_enchant;
  const firstItemGems = data?.first_item_gems;
  const secondItemGems = data?.second_item_gems;
  const firstItemEnchantItemId = data?.first_item_enchant_item_id;
  const firstItemEmbellishmentItemIds = data?.first_item_embellishment_item_ids;
  const secondItemEmbellishmentItemIds = data?.second_item_embellishment_item_ids;
  const firstItemMissiveItemId = data?.first_item_missive_item_id;
  const secondItemMissiveItemId = data?.second_item_missive_item_id;
  const secondItemEnchantItemId = data?.second_item_enchant_item_id;
  const firstItemEnchantDisplayName = data?.first_item_enchant_display_name;
  const secondItemEnchantDisplayName = data?.second_item_enchant_display_name;
  const firstItemEnchantQuality = data?.first_item_enchant_quality;
  const secondItemEnchantQuality = data?.second_item_enchant_quality;

  // Both combo items count as equipped set pieces, so paired-item sets (e.g.
  // Gladiator's Distinction on PvP trinkets) render their bonus as active.
  const comboPieces = [firstItemId, secondItemId].filter((itemId) => itemId > 0).join(":");

  const firstItemStaticData = getWowStatic("item", firstItemId);
  const secondItemStaticData = getWowStatic("item", secondItemId);

  return (
    <div className="armor-item-reversed combo-armor-item">
      <div className="combo-items">
        <div className="armor-item-container">
          <WowTooltip
            type="item"
            id={firstItemId}
            bonusIds={firstItemBonusIds}
            craftingQuality={firstItemCraftingQuality}
            enchant={firstItemEnchantId}
            gems={firstItemGems}
            pcs={comboPieces}
          >
            <Icon staticDataImg={firstItemStaticData?.img} color="rgb(163, 53, 238)" classType="bis-item-icon" />
          </WowTooltip>
          <div className="item-info-right">
            <div className="item-name" style={{ color: "rgb(163, 53, 238)" }}>
              {firstItemStaticData?.name}
            </div>
            <div className="enchant-info">
              <GemIcons gems={firstItemGems} />
              <CraftedIcons embellishmentItemIds={firstItemEmbellishmentItemIds} missiveItemId={firstItemMissiveItemId} />
              {firstItemEnchant ? (
                <>
                  <EnchantTooltip itemId={firstItemEnchantItemId}>
                    <Icon iconSize="18px" staticDataImg={getEnchantImgSrc(firstItemEnchantItemId)} />
                  </EnchantTooltip>
                  <div className="enchant-text">{formatEnchantName(firstItemEnchant, firstItemEnchantDisplayName)}</div>
                  <img
                    style={
                      firstItemEnchantQuality == 2
                        ? { width: "16px", height: "8px", marginLeft: "4px" }
                        : { width: "16px", height: "12px", marginLeft: "4px" }
                    }
                    src={getEnchantQualityIconSrc(firstItemEnchantQuality)}
                  ></img>
                </>
              ) : null}
            </div>
          </div>
        </div>
        <div className="horizontal-line" />
        <div className="armor-item-container">
          <WowTooltip
            type="item"
            id={secondItemId}
            bonusIds={secondItemBonusIds}
            craftingQuality={secondItemCraftingQuality}
            enchant={secondItemEnchantId}
            gems={secondItemGems}
            pcs={comboPieces}
          >
            <Icon staticDataImg={secondItemStaticData?.img} color="rgb(163, 53, 238)" classType="bis-item-icon" />
          </WowTooltip>
          <div className="item-info-right">
            <div className="item-name" style={{ color: "rgb(163, 53, 238)" }}>
              {secondItemStaticData?.name}
            </div>
            <div className="enchant-info">
              <GemIcons gems={secondItemGems} />
              <CraftedIcons embellishmentItemIds={secondItemEmbellishmentItemIds} missiveItemId={secondItemMissiveItemId} />
              {secondItemEnchant ? (
                <>
                  <EnchantTooltip itemId={secondItemEnchantItemId}>
                    <Icon iconSize="18px" staticDataImg={getEnchantImgSrc(secondItemEnchantItemId)} />
                  </EnchantTooltip>
                  <div className="enchant-text">{formatEnchantName(secondItemEnchant, secondItemEnchantDisplayName)}</div>
                  <img
                    style={
                      secondItemEnchantQuality == 2
                        ? { width: "16px", height: "8px", marginLeft: "4px" }
                        : { width: "16px", height: "12px", marginLeft: "4px" }
                    }
                    src={getEnchantQualityIconSrc(secondItemEnchantQuality)}
                  ></img>
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <div className="popularity-container">
        <div className="popularity-value">{parseFloat(popularity).toFixed(1) + "%"}</div>
        <div className="popularity-label">
          ({count?.toLocaleString("en-US")} {encounterType.toLowerCase() === "pvp" ? "players" : "parses"})
        </div>
      </div>
    </div>
  );
};

export default ArmorItemCombo;
